module.exports = __webpack_public_path__ + "img/SCOT-alt.340856ec.svg";